document.addEventListener('DOMContentLoaded', function () {
  var groups = document.querySelectorAll('.custom-product-accordion');

  function AccordionItem(el, group) {
    this.el = el;
    this.group = group;
    this.summary = el.querySelector('.custom-product-accordion__summary');
    this.content = el.querySelector('.custom-product-accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    var self = this;
    this.summary.addEventListener('click', function (e) {
      e.preventDefault();
      self.onClick();
    });
  }

  AccordionItem.prototype.onClick = function () {
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.closeSiblings();
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  };

  AccordionItem.prototype.closeSiblings = function () {
    var self = this;
    this.group.items.forEach(function (item) {
      if (item !== self && item.el.open) {
        item.shrink();
      }
    });
  };

  AccordionItem.prototype.shrink = function () {
    var self = this;
    this.isClosing = true;

    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );

    this.animation.onfinish = function () {
      self.onAnimationFinish(false);
    };
    this.animation.oncancel = function () {
      self.isClosing = false;
    };
  };

  AccordionItem.prototype.open = function () {
    var self = this;
    this.el.style.height = this.el.offsetHeight + 'px';
    this.el.open = true;
    window.requestAnimationFrame(function () {
      self.expand();
    });
  };

  AccordionItem.prototype.expand = function () {
    var self = this;
    this.isExpanding = true;

    var startHeight = this.el.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );

    this.animation.onfinish = function () {
      self.onAnimationFinish(true);
    };
    this.animation.oncancel = function () {
      self.isExpanding = false;
    };
  };

  AccordionItem.prototype.onAnimationFinish = function (open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  groups.forEach(function (groupEl) {
    var group = { items: [] };
    groupEl.querySelectorAll('.custom-product-accordion__item').forEach(function (itemEl) {
      group.items.push(new AccordionItem(itemEl, group));
    });
  });
});